






















































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import contestService from '../../modules/contests/services/ContestService'
import ChooseCaptain from '../../modules/contests/components/ChooseCaptain.vue';
import TeamImage from '@/shared/components/ui/TeamImage.vue';
import PlayerModal from '@/shared/components/PlayerModal.vue';
import PlayerList from '@/shared/components/PlayerList.vue';
import { Getter } from 'vuex-class'
import { USERNAME } from '../../modules/auth/store/constants';
import JoinContest from '@/shared/components/JoinContest.vue';
import AcceptPaymentModal from '@/shared/components/AcceptPaymentModal.vue'
import { getIdFromIri } from '@/shared/utils';
import { vm } from '@/main';

const playerTypeNames  = ['GK', 'DF', 'MD', 'FW'];

@Component({
    components: {
        ChooseCaptain,
        TeamImage,
        PlayerModal,
        PlayerList,
        JoinContest,
        AcceptPaymentModal,
    },
})
export default class ContestLineUp extends Vue {
    @Getter(USERNAME) username!: string;

    private joinContestModal: boolean = false;
    private paymentModal: boolean = false;
    private joinContestId = 0;
    private selectedEntry = 0;
    private contest: any = {}; // lineupChangesAllowed lineupChangesTime
    private competition: any = {};
    private playerTypes = [0, 1, 2, 3];
    private playerTypesNames = playerTypeNames;
    private playerModal = false;
    private selectedPlayerInfoId: number = 0;
    private selectedPlayerType = 0;
    private view: string = 'pitch';
    private availablePlayers = [];
    private search = '';
    private lineUpTypes = ['4-3-3', '4-4-2', '4-5-1'];
    private selectedLineUp = this.lineUpTypes[0];
    private selectedPlayer = null;
    private playersLinedUp = 0;
    private initialLineUp = [
        new Array(1).fill({id: null, name: '', price: 0, rating: 0}),
        new Array(parseInt(this.selectedLineUp.split('-')[0])).fill({id: null, name: '', price: 0, rating: 0}),
        new Array(parseInt(this.selectedLineUp.split('-')[1])).fill({id: null, name: '', price: 0, rating: 0}),
        new Array(parseInt(this.selectedLineUp.split('-')[2])).fill({id: null, name: '', price: 0, rating: 0}),
        new Array(4).fill({id: null, name: '', price: 0, rating: 0}),
    ];
    private lineUp = [...this.initialLineUp];
    private chooseCaptainOpen = false;
    private mobilePlayers = false;
    private mobilePosition = 0;
    private mobileIndex = 0;

    private joinContest() {
        if (this.entries.length >= this.contest.maximumEntriesPerPlayer) {
            return
        }
        this.joinContestId = this.contest.id;
        this.joinContestModal = true;
    }

    private closeModals() {
        this.joinContestModal = false;
        this.paymentModal = false;
    }

    private openPaymentModal() {
        this.paymentModal = true;
    }

    private get budgetUsage() {
        let price = this.currentGoalkeeper.map(player => player.price).reduce((a, b) => a + b, 0) +
        this.currentDefenders.map(player => player.price).reduce((a, b) => a + b, 0) +
        this.currentMidfielders.map(player => player.price).reduce((a, b) => a + b, 0) +
        this.currentForwarders.map(player => player.price).reduce((a, b) => a + b, 0) +
        this.currentDock.map(player => player.price).reduce((a, b) => a + b, 0);
        return price * 100
    }

    private canAddMorePlayers() {
        return this.budgetUsage < this.contest.budgetAmount;
    }

    private get timeUntilChangesAreAllowedOrNot() {
        const time = new Date(this.contest.lineupChangesTime).getTime() - new Date().getTime();

        if (time < 0) {
            return Date.now()
        }

        return time
    }

    @Watch('selectedEntry')
    private async updateLineUp() {
        const lineUp = this.entries.find((x: any) => x['@id'] === this.selectedEntry).lineup;

        if (!lineUp) {
          this.lineUp = [...this.initialLineUp];
          this.updatePlayersLinedUp();
          return
        }

        this.lineUp = [
            [ {
                id: lineUp.goalkeeper['@id'].split('/')[lineUp.goalkeeper['@id'].split('/').length - 1],
                name: lineUp.goalkeeper.name,
                imageUrl: lineUp.goalkeeper.imageUrl,
                prettyPrice: '$' + lineUp.goalkeeper.moneyAmount / 100000000 + 'M',
                price: lineUp.goalkeeper.moneyAmount,
                rating: 12
                // team: lineUp.goalkeeper.team.name
              }
            ],
            [ ...lineUp.defenders.map((x: any) =>
                ({
                    name: x.name,
                    id: x['@id'].split('/')[x['@id'].split('/').length - 1],
                    // price: x.price,
                    rating: x.rating,
                    imageUrl: x.imageUrl,
                    prettyPrice: '$' + x.moneyAmount / 100000000 + 'M',
                    price: x.moneyAmount,
                    // team: x.team.name
                })
            )],
            [ ...lineUp.midfielders.map((x: any) =>
                ({
                    name: x.name,
                    id: x['@id'].split('/')[x['@id'].split('/').length - 1],
                    // price: x.price,
                    rating: x.rating,
                    imageUrl: x.imageUrl,
                    prettyPrice: '$' + x.moneyAmount / 100000000 + 'M',
                    price: x.moneyAmount,
                    // team: x.team.name
                })
            )],
            [ ...lineUp.forwarders.map((x: any) =>
                ({
                    name: x.name,
                    id: x['@id'].split('/')[x['@id'].split('/').length - 1],
                    // price: x.price,
                    rating: x.rating,
                    imageUrl: x.imageUrl,
                    prettyPrice: '$' + x.moneyAmount / 100000000 + 'M',
                    price: x.moneyAmount,
                    // team: x.team.name
                })
            )],
            [ ...lineUp.bench.map((x: any) =>
                ({
                    name: x.name,
                    id: x['@id'].split('/')[x['@id'].split('/').length - 1],
                    // price: x.price,
                    rating: x.rating,
                    imageUrl: x.imageUrl,
                    prettyPrice: '$' + x.moneyAmount / 100000000 + 'M',
                    price: x.moneyAmount,
                    // team: x.team.name
                })
            )],
        ];
        this.updatePlayersLinedUp();
    }

    private async handleSearchChange() {
        this.availablePlayers = [];
        this.nextPlayerPage = '';
        this.isLastPlayerPage = false;
        this.canFetchMorePlayers = true;
        await this.fetchPlayers()
    }

    @Watch('selectedPlayerType')
    private async onSelectedPlayerTypeChanges() {
        this.availablePlayers = [];
        this.nextPlayerPage = '';
        this.isLastPlayerPage = false;
        this.canFetchMorePlayers = true;
        await this.fetchPlayers()
    }

    private setView(type: string): void {
        this.view = type;
    }

    private get contestId() {
        return this.$route.params['id']
    }

    private nextPlayerPage = '';
    private isLastPlayerPage = false;
    private canFetchMorePlayers = true;

    get players() {
        return this.availablePlayers;
    }

    private changeLineUpType(type:string) {
        this.selectedLineUp = type;
        this.lineUp = [
            new Array(1).fill({id: null, name: ''}),
            new Array(parseInt(this.selectedLineUp.split('-')[0])).fill({id: null, name: ''}),
            new Array(parseInt(this.selectedLineUp.split('-')[1])).fill({id: null, name: ''}),
            new Array(parseInt(this.selectedLineUp.split('-')[2])).fill({id: null, name: ''}),
            new Array(4).fill({id: null, name: ''}),
        ];
    }

    private selectPlayer(player: any, mobile = false) {
        if (player.price > (this.contest.budgetAmount - this.budgetUsage)) {
            vm.$notify({
                group: 'errors',
                title: 'Error',
                text: 'No tienes dinero suficiente',
                type: 'error',
            });
            return
        }
        this.mobilePlayers = false;
        if (mobile) {
            const index = this.mobileIndex;
            const position = this.mobilePosition;
            const lineupCopy = {...this.lineUp};
            lineupCopy[position][index] = {...player};
            this.lineUp = { ...lineupCopy };
            this.updatePlayersLinedUp();
        }

        if (!this.playerIsAligned(player)) {
            const index = this.lineUp[player.position - 1].findIndex(x => x.id === null);
            const lineupCopy = {...this.lineUp};
            if (index !== -1) {
                lineupCopy[player.position - 1][index] = {...player};
            } else {
                if (this.lineUp[4][player.position - 1].id === null) {
                    lineupCopy[4][player.position - 1] = {...player};
                }
            }
            this.lineUp = { ...lineupCopy };
            this.updatePlayersLinedUp();
        }
    }

    private addPlayer(position: number, mobile = false, index = 0) {
        this.selectedPlayerType = position;
        if (mobile) {
            this.mobilePlayers = true;
            this.mobilePosition = position;
            this.mobileIndex = index;
        }
    }

    private removePlayer(position: number, index: number) {
        const lineUpCopy = {...this.lineUp};
        //@ts-ignore
        lineUpCopy[position][index].id = null;
        //@ts-ignore
        lineUpCopy[position][index].name = '';

        this.lineUp = {...lineUpCopy};
        this.updatePlayersLinedUp();
    }

    private updatePlayersLinedUp() {
        this.playersLinedUp = this.lineUp[0].filter((x: any) => x.id !== null).length +
                this.lineUp[1].filter((x: any) => x.id !== null).length +
                this.lineUp[2].filter((x: any) => x.id !== null).length +
                this.lineUp[3].filter((x: any) => x.id !== null).length +
                this.lineUp[4].filter((x: any) => x.id !== null).length;
    }

    private playerIsAligned(player: any) {
        return this.lineUp[0].find((x: any) => x.id === player.id) ||
            this.lineUp[1].find((x: any) => x.id === player.id) ||
            this.lineUp[2].find((x: any) => x.id === player.id) ||
            this.lineUp[3].find((x: any) => x.id === player.id) ||
            this.lineUp[4].find((x: any) => x.id === player.id);
    }
    private get currentGoalkeeper() {
        return this.lineUp[0].filter((x: any) => x.id !== null);
    }

    private get currentDefenders() {
        return this.lineUp[1].filter((x: any) => x.id !== null);
    }

    private get currentMidfielders() {
        return this.lineUp[2].filter((x: any) => x.id !== null);
    }

    private get currentForwarders() {
        return this.lineUp[3].filter((x: any) => x.id !== null);
    }

    private get currentDock() {
        return this.lineUp[4].filter((x: any) => x.id !== null);
    }

    private get entries(): any {
        if (!this.contest || !this.contest.entries) {
            return [];
        }
        // @ts-ignore
        return this.contest.entries.filter(x => x.user.username === this.username);
    }

    private async submit(data: any) {
        const { selectedCaptain, selectedSubCaptain } = data;
        try {
            const toSubmitData = {
                formation: this.selectedLineUp,
                lineup: {
                    goalkeeper: [...this.lineUp[0].map((x: any) => parseInt(x.id, 10))][0],
                    defenders: [...this.lineUp[1].map((x: any) => parseInt(x.id, 10))],
                    midfielders: [...this.lineUp[2].map((x: any) => parseInt(x.id, 10))],
                    forwarders: [...this.lineUp[3].map((x: any) => parseInt(x.id, 10))],
                    bench: [...this.lineUp[4].map((x: any) => parseInt(x.id, 10))],
                }
                ,
                captain: parseInt(selectedCaptain.id, 10),
                subcaptain: parseInt(selectedSubCaptain.id, 10),
            };

            await contestService.submitLineUp(toSubmitData, getIdFromIri(this.selectedEntry.toString()));
            this.$router.push('/contests');
        } catch (e) {
            (this as any).$notify({
                group: 'errors',
                title: 'Error',
                text: 'Mensaje de error aqui!',
                type: 'error',
            });
        }
    }

    private async fetchContestData() {
        this.contest = await contestService.fetchContestDetails(this.contestId);
        this.contest.budgetAmount = this.contest.budgetAmount / 100;
        this.selectedEntry = this.entries[0]['@id'];
    }

    private async fetchCompetitionData() {
        const competitionId = getIdFromIri(this.contest.competition['@id']);
        this.competition = await contestService.fetchCompetitionData(competitionId);
    }

    private errorNeed15Players() {
        (this as any).$notify({
                group: 'errors',
                title: 'Error',
                text: 'Debes alinear mínimo 15 jugadores',
                type: 'error',
            });
    }

    private errorLineUpChangesDisabled() {
        (this as any).$notify({
            group: 'errors',
            title: 'Error',
            text: 'En este momento no puedes modificar tu alineación',
            type: 'error',
        });
    }

    private openPlayerModal(id: number) {
        this.playerModal = true;
        this.selectedPlayerInfoId = id;
    }

    private closePlayerModal() {
        this.playerModal = false;
    }

    private async trySubmit() {
        if (this.playersLinedUp === 15 && this.contest.lineupChangesAllowed) {
            this.chooseCaptainOpen = true;
            return;
        }

        if (this.playersLinedUp !== 15) {
            this.errorNeed15Players();
        }

        if (!this.contest.lineupChangesAllowed) {
            this.errorLineUpChangesDisabled();
        }

    }

    private async mounted() {
        await this.fetchContestData();
        await this.fetchCompetitionData();
        await this.fetchPlayers();
    }

    private async fetchPlayers() {
        this.canFetchMorePlayers = false;

        setTimeout(() => {
            this.canFetchMorePlayers = true;
        }, 1000);

        const seasonId = getIdFromIri(this.contest.season['@id']);
        const playerResponse = await contestService.fetchContestPlayers(
            this.contestId,
            this.selectedPlayerType + 1,
            seasonId,
            this.nextPlayerPage,
            this.search
        );
        // @ts-ignore
        this.availablePlayers = [...this.availablePlayers, ...playerResponse.players];

        if (playerResponse.nextpage) {
            this.nextPlayerPage = playerResponse.nextpage;
            return
        } else {
            this.isLastPlayerPage = true;
        }

    }

    private async handlePlayersScroll(el: any) {
        if((el.srcElement.offsetHeight + el.srcElement.scrollTop) >= el.srcElement.scrollHeight) {
            if (!this.isLastPlayerPage && this.canFetchMorePlayers) {
                await this.fetchPlayers()
            }
        }
    }

}
